import { create } from "zustand";
import { deleteData, getData, postData, putData } from "../utils/formHelpers";
import {
  CommentsSaveTypes,
  CommentsTypes,
} from "../../app/pages/user/Samples/SampleProcessing/utils/comments.types";
import { errorAlert, successAlert } from "../../app/utils/alerts";

type UseComments = {
  save: (uncertainty: CommentsSaveTypes) => Promise<boolean>;
  remove: (id: CommentsTypes["id"]) => Promise<boolean>;
  fetchSample: (id: CommentsTypes["id"]) => Promise<void>;
  loading: boolean;
  loadingSave: boolean;
  commentsList: CommentsTypes[];
};

export const useComments = create<UseComments>((set, get) => ({
  commentsList: [],
  loading: false,
  loadingSave: false,
  fetchSample: async (id) => {
    set({ loading: true });
    try {
      const endpointSample = `/sample-registration/${id}`;

      const { data: response } = await getData(endpointSample);
      if (response) {
        set({
          commentsList: response.comments,
        });
      }
    } catch (error) {
      console.error("Error fetching entities:", error);
    } finally {
      set({ loading: false });
    }
  },

  save: async (uncertainty: Partial<any>) => {
    let hasErrors = false;
    set({ loadingSave: true });

    try {
      const isNew = !uncertainty?.id;
      const endpoint = `/comments/${
        isNew ? "create" : uncertainty.id + "/edit"
      }`;

      const response = isNew
        ? await postData(endpoint, uncertainty)
        : await putData(endpoint, uncertainty);
      hasErrors = !response.success;
      if (!hasErrors) successAlert("Comentario guardado correctamente");
      return response.success;
    } catch (error) {
      hasErrors = true;
      errorAlert("Error al guardar el comentario");
      return false;
    } finally {
      set({ loadingSave: false });
    }
  },

  remove: async (id: CommentsTypes["id"]) => {
    try {
      set({ loading: true });
      const endpoint = `/comments/${id}`;

      await deleteData(endpoint);

      return true;
    } catch (error) {
      return false;
    } finally {
      set({ loading: false });
    }
  },
}));
